import { Footer } from "../footer";
import { NavBar } from "../navbar";

export const Layout = ({ children, navBarClassName = "" }) => {
  return (
    <div className="w-full h-screen max-h-[100dvh] flex flex-col overflow-y-scroll satoshi text-main-black">
      <NavBar className={navBarClassName} />

      <div className="flex-1">{children}</div>

      <Footer />
    </div>
  );
};
